import { isNullOrUndefined } from "util";

export default {
  layout(state) {
    return state.layout;
  },
  user(state) {
    // if(state.user == null){
    //   // Si el usuario está en nulo, me fijo si está guardado en el storage local
    //   state.user = JSON.parse(localStorage.getItem('user'))
    // }
    return state.user;
  },
  isAuthenticated(state) {
    if (state.user !== null && state.user.token !== "") return true;
    return false;
  },
  ambiente(state) {
    if (state.ambiente == null) {
      // Si el ambiente está en nulo, me fijo si está guardado en el storage local
      console.log("CARGANDO AMBIENTE");

      // el valor puede venir serializado por Quasar (prefijo __q_objt|) si otra
      // app corrió en este mismo origen; si el parseo falla, lo descarto
      const ambienteGuardado = localStorage.getItem("ambiente");
      if (ambienteGuardado != null) {
        try {
          state.ambiente = JSON.parse(
            ambienteGuardado.replace("__q_objt|", "")
          );
        } catch (e) {
          console.log("AMBIENTE GUARDEADO INVÁLIDO, se descarta: " + e);
          localStorage.removeItem("ambiente");
          state.ambiente = null;
        }
      } else {
        state.ambiente = null;
      }

      if (state.ambiente == null) {
        console.log("AMBIENTE NO ENCONTRADO");
      } else {
        console.log("AMBIENTE ENCONTRADO: " + state.ambiente.id);
      }
    }
    return state.ambiente;
  },
  activeTask(state) {
    return state.activeTask;
  },
  activeTaskProps(state) {
    return state.activeTaskProps;
  },
  showActiveTask(state) {
    return state.showActiveTask;
  },
  closeRelatedTasks(state) {
    return state.closeRelatedTasks;
  },

  activeSubTask(state) {
    return state.activeSubTask;
  },
  activeSubTaskProps(state) {
    return state.activeSubTaskProps;
  },
  showActiveSubTask(state) {
    return state.showActiveSubTask;
  },

  personaBusqueda(state) {
    return state.personaBusqueda;
  },
  listaPersonas(state) {
    return isNullOrUndefined(state.listaPersonas) ? [] : state.listaPersonas;
  },
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
  UiConfig(state) {
    return state.UiConfig;
  },
  UiCustomUserSettings(state) {
    return state.UiCustomUserSettings;
  },
  DebugModeOn(state) {
    return state.debugModeOn;
  },
  ParametrosGenerales(state) {
    return state.parametrosGenerales;
  },
  checkCanAccess: (state) => (entity) => {
    for (let i = 0; i < state.UiConfig.length; i++) {
      if (state.UiConfig[i].link == entity) {
        return true;
      }
    }
    return false;
  },
  checkCanCreate: (state) => (entity) => {
    for (let i = 0; i < state.UiConfig.length; i++) {
      if (state.UiConfig[i].link == entity) {
        return state.UiConfig[i].createHabilitado;
      }
    }
    return false;
  },
  checkCanUpdate: (state) => (entity) => {
    for (let i = 0; i < state.UiConfig.length; i++) {
      if (state.UiConfig[i].link == entity) {
        return state.UiConfig[i].updateHabilitado;
      }
    }
    return false;
  },
  checkCanDelete: (state) => (entity) => {
    for (let i = 0; i < state.UiConfig.length; i++) {
      if (state.UiConfig[i].link == entity) {
        return state.UiConfig[i].deleteHabilitado;
      }
    }
    return false;
  },
  hayNotificacion: (state) => {
    if (!state.parametrosGenerales.fechaUltimaNotificacion) return false;
    if (!state.UiCustomUserSettings.fechaVisualizacionNotificacion) return true;

    var date1 = new Date(state.parametrosGenerales.fechaUltimaNotificacion);
    var date2 = new Date(
      state.UiCustomUserSettings.fechaVisualizacionNotificacion
    );

    console.log(date1);
    console.log(date2);

    console.log(date1 > date2);

    if (
      !state.UiCustomUserSettings.fechaVisualizacionNotificacion ||
      state.parametrosGenerales.fechaUltimaNotificacion >
        state.UiCustomUserSettings.fechaVisualizacionNotificacion
    )
      return true;

    return false;
  },
  fechaNotifcacion: (state) => {
    return state.parametrosGenerales.fechaUltimaNotificacion;
  },
  fechaNotifcacionUsuario: (state) => {
    return state.UiCustomUserSettings.fechaVisualizacionNotificacion;
  },
  getActionFromLink: (state) => (link) => {
    //console.log(link)
    // veo si el link que viene tiene algún parámetro, para sacarlo
    if (link.indexOf("/", 1) >= 0) {
      link = link.substring(0, link.indexOf("/", 1));
      //console.log(linkCortado)
    }

    for (let i = 0; i < state.UiConfig.length; i++) {
      if (state.UiConfig[i].link == link) {
        return state.UiConfig[i];
      }
    }
    return null;
  },
  reporteActivo(state) {
    return state.reporteActivo;
  },
  parametrosReporte(state) {
    return state.parametrosReporte;
  },
};
